import { matchBreakpoint } from '@chh/ui/js/matchBreakpoint';

class Interactive extends HTMLElement {
  connectedCallback() {
    this._iframeNode = this.querySelector('iframe');

    this._controller = new AbortController();

    // Wait for window load before activating iframe
    if (document.readyState === 'complete') {
      this._init();
    } else {
      window.addEventListener('load', this._init, { signal: this._controller.signal });
    }
  }

  disconnectedCallback() {
    this._controller?.abort();
  }

  _init = () => {
    this._mql = matchBreakpoint('desktop');
    this._mql.addEventListener('change', this._onBreakpointChange, {
      signal: this._controller.signal,
    });
    this._onBreakpointChange(this._mql);
  };

  _onBreakpointChange = (e) => {
    if (e.matches) {
      this._iframeNode.src = this._iframeNode.dataset.src;
    }
  };
}

customElements.define('chh-interactive', Interactive);

export default Interactive;
